<template>
  <fragment>
    <p-panel-properties-group title="Table" class="table-panel">
      <p-property-tile icon="mdi-format-color-fill" title="Header Background Color">
        <preset-input-color v-model="value.data.headerColor" default-value="#00000000"></preset-input-color>
      </p-property-tile>

      <p-property-tile icon="mdi-border-style" title="Border Style">
        <p-panel-input-select :items="borderOptions" v-model="value.data.borderStyle" item-text="text"
                              :return-object="true"/>
      </p-property-tile>

      <p-property-tile icon="mdi-border-color" title="Border Color">
        <preset-input-color :value="value.data.borderColor" @input="value.data.borderColor = $event" default-value="#000000ff"></preset-input-color>
      </p-property-tile>

      <p-property-tile icon="mdi-minus-thick" title="Border Thickness" class="table-panel__border-thickness">
        <p-panel-simple-input-number :min="1" v-model="value.data.borderThickness"></p-panel-simple-input-number>
      </p-property-tile>

      <p-property-tile v-if="showAlternatePadding" title="Cell Padding" icon="mdi-arrow-all" :extended="true">
        <template v-if="!paddingActionLocked" slot="content">
          <div class="padding-values">
            <div class="padding-values__item">
              <span>Top</span>
              <p-panel-simple-input-number :min="0" v-model="value.data.cellPadding[0]"
                                           :height="30"></p-panel-simple-input-number>
            </div>
            <div class="padding-values__item">
              <span>Right</span>
              <p-panel-simple-input-number :min="0" v-model="value.data.cellPadding[1]"
                                           :height="30"></p-panel-simple-input-number>
            </div>
            <div class="padding-values__item">
              <span>Bottom</span>
              <p-panel-simple-input-number :min="0" v-model="value.data.cellPadding[2]"
                                           :height="30"></p-panel-simple-input-number>
            </div>
            <div class="padding-values__item">
              <span>Left</span>
              <p-panel-simple-input-number :min="0" v-model="value.data.cellPadding[3]"
                                           :height="30"></p-panel-simple-input-number>
            </div>
          </div>
        </template>
        <div class="padding-action">
          <p-panel-simple-input-number
              v-if="paddingAllSameValues"
              :min="0"
              v-model="paddingTop"></p-panel-simple-input-number>
          <v-text-field v-else placeholder="mixed" disabled></v-text-field>
          <v-icon @click="togglePaddingAction">{{ paddingActionIcon }}</v-icon>
        </div>
      </p-property-tile>
    </p-panel-properties-group>
  </fragment>
</template>
<script>
import PPanelPropertiesGroup from "../_components/utils/PPanelPropertiesGroup.vue"
import {Fragment} from "vue-fragment"
import PresetInputColor from "../../components/slides/styles/PresetInputColor.vue"
import PPropertyTile from "../_components/utils/PPropertyTile.vue"
import PPanelSimpleInputNumber from "../_components/utils/PPanelSimpleInputNumber.vue";
import PPanelInputSelect from "../_components/utils//PPanelInputSelect.vue";

export default {
  components: {
    PPanelInputSelect,
    PPanelSimpleInputNumber,
    PPropertyTile,
    PresetInputColor,
    PPanelPropertiesGroup,
    Fragment
  },
  props: [
    "value",
  ],
  computed: {
    paddingActionLocked() {
      return this.value.data.paddingLocked
    },
    paddingAllSameValues() {
      return this.showAlternatePadding ? new Set(this.value.data.cellPadding).size === 1 : false
    },
    paddingActionIcon() {
      return this.paddingActionLocked ? "mdi-lock-outline" : "mdi-lock-open-outline"
    },
  },
  watch: {
    paddingTop: {
      immediate: false,
      handler(value) {
        this.value.data.cellPadding = [value, value, value, value]
      }
    },
  },
  data() {
    return {
      paddingTop: this.value.data.cellPadding[0],
      showAlternatePadding: true,
      borderOptions: ['none', 'solid', 'dashed', 'dotted', 'inset'],
      borderStyle: this.value.data.borderStyle,
    }
  },
  methods: {
    togglePaddingAction() {
      this.value.data.paddingLocked = !this.value.data.paddingLocked
    }
  }
}
</script>

<style>
.table-panel .table-panel__border-thickness .v-text-field {
  margin: 0;
  padding: 0;
}
</style>
